import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['button', 'result', 'period', 'jdgConfig', 'copartnershipConfig'];

  static values = {
    url: String,
  };

  connect() {
    this.buttonTarget.disabled = false;
  }

  async simulate(event) {
    event.preventDefault();

    const period = this.periodTarget.value;
    if (!period) {
      this.showError('Wybierz miesiąc do symulacji.');
      return;
    }

    const jdgConfigId = this.jdgConfigTarget.value;
    const copartnershipConfigId = this.copartnershipConfigTarget.value;

    if (!jdgConfigId && !copartnershipConfigId) {
      this.showError('Wybierz przynajmniej jedną konfigurację.');
      return;
    }

    await this.fetchSimulation(period, jdgConfigId, copartnershipConfigId);
  }

  async fetchSimulation(period, jdgConfigId, copartnershipConfigId) {
    this.setLoading(true);

    const formData = new URLSearchParams();
    formData.append('period', period);
    if (jdgConfigId) formData.append('commission_config_jdg_id', jdgConfigId);
    if (copartnershipConfigId) formData.append('commission_config_copartnership_id', copartnershipConfigId);

    try {
      const response = await fetch(this.urlValue, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': this.csrfToken,
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/x-www-form-urlencoded',
          Accept: 'text/html',
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const html = await response.text();
      if (!response.ok) {
        this.showError(html || 'Wystąpił błąd podczas symulacji.');
        return;
      }
      this.resultTarget.innerHTML = html;
      this.attachDetailToggles();
    } catch (error) {
      this.showError('Wystąpił błąd podczas symulacji.');
      console.error('Simulation error:', error);
    } finally {
      this.setLoading(false);
    }
  }

  setLoading(loading) {
    if (loading) {
      this.buttonTarget.disabled = true;
      this.buttonTarget.textContent = 'Obliczam...';
      this.resultTarget.innerHTML = '<div class="loaderOverlay" style="position:relative;min-height:60px;"></div>';
    } else {
      this.buttonTarget.disabled = false;
      this.buttonTarget.textContent = 'Symuluj';
    }
  }

  attachDetailToggles() {
    this.resultTarget.querySelectorAll('[data-toggle-details]').forEach((row) => {
      row.addEventListener('click', () => {
        const detailRow = row.nextElementSibling;
        if (detailRow) {
          detailRow.hidden = !detailRow.hidden;
          const arrow = row.querySelector('[data-arrow]');
          if (arrow) arrow.textContent = detailRow.hidden ? '▶' : '▼';
        }
      });
    });
  }

  showError(message) {
    const p = document.createElement('p');
    p.className = 'flash-error';
    p.textContent = message;
    this.resultTarget.replaceChildren(p);
  }

  get csrfToken() {
    const meta = document.querySelector('meta[name="csrf-token"]');
    return meta ? meta.content : '';
  }
}
